export default {
    getFields(Selector) {
        return {
            "contact[recipient]": {required: true},
            "contact[subject]": {required: true, minlength: 3, maxlength: 100},
            "contact[name]": {required: true, minlength: 3, maxlength: 100},
            "contact[company]": {maxlength: 100},
            "contact[address]": {maxlength: 100},
            "contact[email]": {
                require_from_group: [1, ".validationGroup"],
               
            },
            "contact[phone]": {
             
                require_from_group: [1, ".validationGroup"],
               
            },
            "contact[message]": {required: true, minlength: 10, maxlength: 1000},
            "contact[agree_rules]": {required: true},
        }
    }
}export default {
    getFields(Selector) {
        return {
            "contact[recipient]": {required: true},
            "contact[subject]": {required: true, minlength: 3, maxlength: 100},
            "contact[name]": {required: true, minlength: 3, maxlength: 100},
            "contact[company]": {maxlength: 100},
            "contact[address]": {maxlength: 100},
            "contact[email]": {
                require_from_group: [1, ".validationGroup"],
               
            },
            "contact[phone]": {
             
                require_from_group: [1, ".validationGroup"],
               
            },
            "contact[message]": {required: true, minlength: 10, maxlength: 1000},
            "contact[agree_rules]": {required: true},
        }
    }
}